import {HeaderFooter, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalHeaderFooterPositions} from "./PortalHeaderFooterPositions";
import {PortalPagesHeaderFooter} from "./PortalPagesHeaderFooter";

export class PortalHeaderFooter extends HeaderFooter implements Parameter {
	constructor(data: any) {
		super(data);

		this.pages = PortalPagesHeaderFooter.fromJson(data?.pages);
		this.header = PortalHeaderFooterPositions.fromJson(data?.header);
		this.footer = PortalHeaderFooterPositions.fromJson(data?.footer);
	}

	public static fromJson(data: any): PortalHeaderFooter {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalHeaderFooter(data);
	}

	public clone(): PortalHeaderFooter {
		return PortalHeaderFooter.fromJson(this.toJson());
	}
}